import Vue from 'vue'
import Router from 'vue-router'
import AppLayout from '../layouts/AppLayout'
Vue.use(Router)

const Login = () => import('../pages/login')
const order = () => import('../views/generator/order')
const feedBack = () => import('../views/generator/feedBack')
const monery = () => import('../views/generator/monery')
const userInfo = () => import('../views/generator/userInfo')
const pRegister = () => import('../views/phone/pRegister')
const pRegisterWorker = () => import('../views/phone/pRegisterWorker')
const pRegister2 = () => import('../views/phone/pRegister2')
const pLogin = () => import('../views/phone/pLogin')
const pLoginU = () => import('../views/phone/pLoginU')
const pMain = () => import('../views/phone/pMain')
const pOrder = () => import('../views/phone/pOrder')
const pRegisterInfo = () => import('../views/phone/pRegisterInfo')
const pRegisterInfoWorker = () => import('../views/phone/pRegisterInfoWorker')
const pSure = () => import('../views/phone/pSure')
const pSureWx = () => import('../views/phone/pSureWx')
const pPdf = () => import('../views/phone/pPdf')
const pCoupon = () => import('../views/phone/pCoupon')
const couponManage = () => import('../views/generator/couponManage')
const doc = () => import('../views/generator/doc')
const registerManager = () => import('../views/generator/registerManager')
const userOrder = () => import('../views/generator/userOrder')
const borrowToolBox = () => import('../views/generator/borrowToolBox')
const pyLogin = () => import('../views/py/pyLogin.vue')
const pyLogin2 = () => import('../views/py/pyLogin2.vue')
const pyOrder = () => import('../views/py/pyOrder.vue')
const pyZc = () => import('../views/py/pyZc.vue')
const router = new Router({
  mode: 'history',
  routes: [
    {
      name: '',
      path: '/',
      component: Login
    },
    {
      name: 'login',
      path: '/login',
      component: Login
    },
    {
      name: 'layout',
      path: '',
      component: AppLayout,
      children: [
        {
          name: 'order',
          path: '/order',
          meta: {
            title: '订单管理'
          },
          component: order
        }, {
          name: 'feedBack',
          path: '/feedBack',
          meta: {
            title: '反馈管理'
          },
          component: feedBack
        }, {
          name: 'monery',
          path: '/monery',
          meta: {
            title: '资金管理'
          },
          component: monery
        }, {
          name: 'userInfo',
          path: '/userInfo',
          meta: {
            title: '用户信息'
          },
          component: userInfo
        }, {
          name: 'couponManage',
          path: '/couponManage',
          component: couponManage,
          meta: {
            title: '优惠券管理'
          }
        }, {
          name: 'borrowToolBox',
          path: '/borrowToolBox',
          component: borrowToolBox,
          meta: {
            title: '借用工具盒'
          }
        }, {
          name: 'doc',
          path: '/doc',
          component: doc,
          meta: {
            title: '使用说明书'
          }
        }, {
          name: 'registerManager',
          path: '/registerManager',
          meta: {
            title: '邀请用户'
          },
          component: registerManager
        }, {
          name: 'userOrder',
          path: '/userOrder',
          meta: {
            title: '用户订单'
          },
          component: userOrder
        }
      ]
    },
    // 手机版
    {
      name: 'pRegister', // 手机注册 // 非易术佳公众号注册的
      path: '/pRegister',
      component: pRegister
    },
    {
      name: 'pRegisterWorker', // 手机注册 // 非易术佳公众号注册的
      path: '/pRegisterWorker',
      component: pRegisterWorker
    },
    {
      name: 'pRegister2', // 手机注册 // 易术佳公众号注册的
      path: '/pRegister2',
      component: pRegister2
    },
    {
      name: 'pRegisterInfo', // 手机注册
      path: '/pRegisterInfo',
      component: pRegisterInfo
    },
    {
      name: 'pRegisterInfoWorker', // 手机注册
      path: '/pRegisterInfoWorker',
      component: pRegisterInfoWorker
    },
    {
      name: 'pLogin', // 手机登录
      path: '/pLogin',
      component: pLogin
    },
    {
      name: 'pLoginU', // 手机登录
      path: '/pLoginU',
      component: pLoginU
    },
    {
      name: 'pOrder', // 手机新建订单
      path: '/pOrder',
      component: pOrder
    },
    {
      name: 'pMain', // 手机主页
      path: '/pMain',
      component: pMain
    },
    {
      name: 'pSure', // 手机确认pdf
      path: '/pSure',
      component: pSure
    },
    {
      name: 'pSureWx', // 手机确认pdf-微信公众号端
      path: '/pSureWx',
      component: pSureWx
    },
    {
      name: 'pPdf', // 手机确认pdf
      path: '/pPdf',
      component: pPdf
    },
    {
      name: 'pCoupon', // 优惠券
      path: '/pCoupon',
      component: pCoupon
    },
    {
      name: 'pyLogin', // 优惠券
      path: '/pyLogin',
      component: pyLogin
    },
    {
      name: 'pyLogin2', // 优惠券
      path: '/pyLogin2',
      component: pyLogin2
    },
    {
      name: 'pyOrder', // 优惠券
      path: '/pyOrder',
      component: pyOrder
    },
    {
      name: 'pyZc', // 优惠券
      path: '/pyZc',
      component: pyZc
    }
  ]
})
// 路由全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/pRegister' || to.path === '/pRegister2' || to.path === '/pRegisterInfo' || to.path === '/pRegisterInfoWorker' || to.path === '/pRegisterWorker' || to.path === '/' || to.path === '/pLogin' || to.path === '/pLoginU' || to.path === '/pSureWx' || to.path === '/pyLogin' || to.path === '/pyLogin2' || to.path === '/pyZc') {
    next()
  } else {
    let registerToken = localStorage.getItem('token')
    if (registerToken == null || registerToken === '') {
      if (to.path === '/pMain') {
        alert('请先登录')
        return next('/pLogin')
      }
      if (to.path === '/pLoginU') {
        alert('请先登录')
        return next('/pLoginU')
      }
      /* if (to.path === '/pyLogin') {
        return next('/pyLogin')
      }
      if (to.path === '/pyLogin2') {
        return next('/pyLogin2')
      }
      if (to.path === '/pyZc') {
        return next('/pyZc')
      } */
      // alert('无权限，请登录')
      return next('/login')
    } else {
      if (to.path === '' || to.path === '/') {
        return next('/login')
      }
      return next()
    }
  }
})
/* router.beforeEach((to, from, next) => {
  let registeruser = router.app.$options.store.state.registeruser
  if (registeruser != null) {
    next()
    return
  }
  // 登录页面处理
  if (to.name === 'login') {
    next()
    return
  }
  // 非登录页面，验证用户是否登录
  setTimeout(() => {
    // 已登录，存储userInfo
    router.app.$store.commit('setRegisterUserInfo', {
      avatar: '/static/avatar/woman.png',
      realname: '超级管理员'
    })
    next()
  }, 300)
}) */

export default router



// WEBPACK FOOTER //
// ./src/router/index.js